import React from 'react';
import { StyledCloudImage } from './UniversalSearchCard.styles';
import { Card } from '@sections/registry/components';
import { themeSpace } from '@utils/styledTheme.util';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

export const UniversalSearchCard = () => {
  const theme = useTheme();
  const { t } = useTranslation('registry');
  const universalSearchCard = t('shopSection.universalSearchCard');
  return (
    <Card
      eyebrow={universalSearchCard.eyebrow}
      eyebrowVariant="featureHed17"
      eyebrowColor="accentBlue4"
      title={universalSearchCard.title}
      titleVariant="calloutHed32"
      titleColor="mono1"
      wrapperStyles={{ gap: themeSpace(8)({ theme }) }}
    >
      <StyledCloudImage alt={universalSearchCard.imageAlt} optimization="none" src={universalSearchCard.image} mobileResizeWidth={800} />
    </Card>
  );
};
